import React, { useEffect } from "react";
import "./security.css";

const NewSecurity = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="new-security-page">

            <div className="security-container">
                {/* --- Hero Section --- */}
                <div className="sec-hero">
                    <div className="sec-hero-content">
                        <h1 className="sec-hero-title">
                            Security.<br />
                            <span>Without Compromise.</span>
                        </h1>
                        <p className="sec-hero-desc">
                            AGCX uses industry-leading practices to protect your assets, accounts, and data — 24/7 resilience built for what matters most.
                        </p>
                        <div className="sec-hero-actions">
                            <a href="#audit" className="sec-btn-primary">View Audit Reports</a>
                            <a href="#reports" className="sec-btn-outline">View Full Reports</a>
                        </div>
                        <div className="sec-hero-features">
                            <div className="sec-hero-feature"><i className="ri-checkbox-circle-line"></i> Bank-level security</div>
                            <div className="sec-hero-feature"><i className="ri-checkbox-circle-line"></i> 100% Asset Compliance</div>
                            <div className="sec-hero-feature"><i className="ri-checkbox-circle-line"></i> Smart compliance</div>
                            <div className="sec-hero-feature"><i className="ri-checkbox-circle-line"></i> Transparent & Audited</div>
                        </div>
                    </div>
                    <div className="sec-hero-image">
                        <img src="/images/new-security-img/security_bnr_img.png" alt="Security Without Compromise" />
                        <div className="sec-floating-card sec-floating-iot">
                            <img src="/images/new-security-img/trusted_icon4.png" alt="IoT" width="16" /> IoT Monitoring
                        </div>
                        <div className="sec-floating-card sec-floating-asset">
                            <img src="/images/new-security-img/trusted_icon.png" alt="Asset" width="16" /> Asset Management
                        </div>
                    </div>
                </div>

                {/* --- Layered Protection Section --- */}
                <div className="sec-layered">
                    <div className="sec-layered-header">
                        <div className="sec-layered-title">
                            <p>Security At Every Layer</p>
                            <h2>Layered protection<br />built for every threat.</h2>
                        </div>
                        <div className="sec-layered-tabs">
                            <button className="sec-tab active">Platform Security</button>
                            <button className="sec-tab">Smart Protections</button>
                            <button className="sec-tab">Account Security</button>
                        </div>
                    </div>
                    <div className="sec-layered-grid">
                        <div className="sec-layer-card">
                            <div className="sec-layer-icon"><img src="/images/new-security-img/security_layer_icon.svg" alt="Advanced Infrastructure" /></div>
                            <h3>Advanced Infrastructure</h3>
                            <p>Enterprise-grade servers with multi-region redundancy and zero-downtime deployments.</p>
                        </div>
                        <div className="sec-layer-card">
                            <div className="sec-layer-icon"><img src="/images/new-security-img/security_layer_icon2.svg" alt="Smart Risk Control" /></div>
                            <h3>Smart Risk Control</h3>
                            <p>Real-time AI-powered threat detection that neutralizes risks before they reach you.</p>
                        </div>
                        <div className="sec-layer-card">
                            <div className="sec-layer-icon"><img src="/images/new-security-img/security_layer_icon3.svg" alt="Zero Access Management" /></div>
                            <h3>Zero Access Management</h3>
                            <p>Strict access policies mean no internal team member can touch your private data.</p>
                        </div>
                        <div className="sec-layer-card">
                            <div className="sec-layer-icon"><img src="/images/new-security-img/security_layer_icon4.svg" alt="Secure Development" /></div>
                            <h3>Secure Development</h3>
                            <p>Every line of code is reviewed, tested, and scanned for vulnerabilities before shipping.</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- Protection In Action Section --- */}
            <div className="security-container">
                <div className="sec-action">
                    <div className="sec-action-content">
                        <div className="sec-action-subtitle">Protection In Action</div>
                        <h2 className="sec-action-title">We don't just promise<br />security — we prove it<br />every single day.</h2>
                        <ul className="sec-action-list">
                            <li><i className="ri-shield-check-line"></i> End-to-end encryption on all transfers</li>
                            <li><i className="ri-smartphone-line"></i> Multi-factor authentication globally enforced</li>
                            <li><i className="ri-settings-4-line"></i> Automated threat response & mitigation</li>
                            <li><i className="ri-bug-line"></i> Continuous penetration testing</li>
                            <li><i className="ri-alarm-warning-line"></i> Real-time anomaly detection & alerts</li>
                        </ul>
                    </div>
                    <div className="sec-action-image">
                        <img src="/images/new-security-img/protection_img.png" alt="Protection In Action" />
                    </div>
                </div>
            </div>

            {/* --- Compliance & Transparency Section --- */}
            <div className="security-container">
                <div className="sec-compliance">
                    <div className="sec-compliance-image">
                        <img src="/images/new-security-img/compliance_transparency_img.png" alt="Compliance & Transparency" />
                    </div>
                    <div className="sec-compliance-content">
                        <div className="sec-compliance-subtitle">Compliance & Transparency</div>
                        <h2 className="sec-compliance-title">We meet the highest global standards<br />— and prove it.</h2>
                        <p className="sec-compliance-desc">
                            Our infrastructure is independently audited every quarter. Every certification is real, every report is public, and every claim is backed by data you can verify.
                        </p>
                        <ul className="sec-compliance-list">
                            <li><i className="ri-checkbox-circle-line"></i> Regular third-party security assessments</li>
                            <li><i className="ri-checkbox-circle-line"></i> Public transparency reports every quarter</li>
                            <li><i className="ri-checkbox-circle-line"></i> User-accessible audit logs at all times</li>
                        </ul>
                        <a href="#audits" className="sec-link">View Our Audits <i className="ri-arrow-right-s-line"></i></a>
                    </div>
                </div>
            </div>

            {/* --- Rely On Section --- */}
            <div className="sec-rely">
                <div className="security-container" style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="sec-rely-content">
                        <div className="sec-rely-subtitle">Advanced Security Features</div>
                        <h2 className="sec-rely-title">Security You Can <span>Rely On,</span><br />Always.</h2>
                        <p className="sec-rely-desc">
                            We are committed to keeping your assets and information safe with the most advanced, multi-layered security architecture available today.
                        </p>
                        <div className="sec-rely-actions">
                            <a href="#trial" className="sec-btn-primary">Start Free Trial</a>
                            <a href="#reports" className="sec-btn-outline">View Full Reports</a>
                        </div>
                    </div>
                    <div className="sec-rely-image">
                        <img src="/images/new-security-img/advanced_security_img.png" alt="Security You Can Rely On" />
                    </div>
                </div>
            </div>

            {/* --- Trusted & Secured Section --- */}
            <div className="security-container">
                <div className="sec-trusted">
                    <h3 className="sec-trusted-title">Trusted & Secured</h3>
                    <div className="sec-trusted-grid">
                        <div className="sec-trusted-card">
                            <div className="sec-trusted-icon"><img src="/images/new-security-img/trusted_icon.png" alt="Multi-Layer Authentication" /></div>
                            <p>Multi-Layer<br />Authentication</p>
                        </div>
                        <div className="sec-trusted-card">
                            <div className="sec-trusted-icon"><img src="/images/new-security-img/trusted_icon2.png" alt="End-to-End Encryption" /></div>
                            <p>End-to-End<br />Encryption</p>
                        </div>
                        <div className="sec-trusted-card">
                            <div className="sec-trusted-icon"><img src="/images/new-security-img/trusted_icon3.png" alt="Full Transparency" /></div>
                            <p>Full<br />Transparency</p>
                        </div>
                        <div className="sec-trusted-card">
                            <div className="sec-trusted-icon"><img src="/images/new-security-img/trusted_icon4.png" alt="AI Monitoring" /></div>
                            <p>AI<br />Monitoring</p>
                        </div>
                        <div className="sec-trusted-card">
                            <div className="sec-trusted-icon"><img src="/images/new-security-img/trusted_icon5.png" alt="Zero-Knowledge Proof" /></div>
                            <p>Zero-Knowledge<br />Proof</p>
                        </div>
                        <div className="sec-trusted-card">
                            <div className="sec-trusted-icon"><img src="/images/new-security-img/trusted_icon6.png" alt="Non-Custodial Secure" /></div>
                            <p>Non-Custodial<br />Secure</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewSecurity;
